import React from 'react';
import NoData from '../../assets/images/No_data.svg';

const NoDataFound = () => {
  return (
    <div className="flex flex-col justify-center items-center p-10 bg-gray-100 rounded-lg shadow-lg text-center ">
      <img src={NoData} alt="No Data Found" width={150} className="mb-4 opacity-90" />
      <p className="text-gray-600 text-xl font-semibold">No Data Found</p>
      <p className="text-gray-500 mt-2">Please try again later or refresh the page.</p>
    </div>
  );
};


export default NoDataFound;

